import { BundleProposal, ProductData, ProductProposal } from '@sitecore/types/manual/be/ProductList';

export const getSitecoreProduct = ({
  technicalProductName,
  enecoProductsList,
}: {
  technicalProductName: string;
  enecoProductsList: ProductProposal[];
}): ProductData | undefined => {
  const sitecoreProduct = enecoProductsList?.find(item => item?.name === technicalProductName);
  return sitecoreProduct?.fields?.data;
};

export const getSitecoreBundle = ({
  technicalProductNameElec,
  technicalProductNameGas,
  enecoProductsBundlesList,
  enecoProductsList,
}: {
  technicalProductNameElec: string;
  technicalProductNameGas: string;
  enecoProductsBundlesList: BundleProposal[];
  enecoProductsList: ProductProposal[];
}) => {
  const sitecoreBundle = enecoProductsBundlesList.find(
    item =>
      item.fields.data.enecoProductsElectricityList.value === technicalProductNameElec &&
      item.fields.data.enecoProductsGasList.value === technicalProductNameGas,
  );
  const elecProduct = enecoProductsList.find(item => item.name === technicalProductNameElec);
  const gasProduct = enecoProductsList.find(item => item.name === technicalProductNameGas);
  return {
    bundleDisplayName: sitecoreBundle?.fields?.data?.bundleDisplayName?.value ?? '',
    bundleContent: sitecoreBundle?.fields?.data?.description?.value ?? '',
    elecProduct,
    gasProduct,
  };
};

export const getSitecorePosition = ({
  technicalProductName,
  enecoProductsList,
}: {
  technicalProductName: string;
  enecoProductsList: ProductProposal[];
}): number => {
  const compareName = (product: ProductProposal) => product.name === technicalProductName;
  return enecoProductsList.findIndex(compareName);
};
